import { motion } from "framer-motion";
import { EnvelopeSimple } from "@phosphor-icons/react";

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      {/* Contact Section */}
      <section className="py-28 md:py-36 lg:py-44 relative" data-testid="contact-hero">
        {/* Background elements */}
        <div className="absolute top-20 right-12 w-48 h-48 border-2 border-[#1565C0]/10 hidden lg:block" />
        <div className="absolute bottom-40 left-20 w-32 h-32 bg-[#00897B]/10 hidden lg:block" />
        
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div 
            className="max-w-3xl"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center gap-3 mb-8">
              <div className="accent-bar"></div>
              <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#1565C0]">Contact</p>
            </div>
            
            <h1 className="font-['Cabinet_Grotesk',sans-serif] text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-[#0D1B2A] leading-[1.1] mb-10" data-testid="contact-heading">
              Let's converse.
            </h1>
            <p className="text-xl md:text-2xl text-[#3D5A73] leading-relaxed mb-16">
              If you would like to connect or have a conversation, feel free to reach out.
            </p>

            {/* Email Display */}
            <div className="bg-[#F0F4F8] p-8 md:p-12 border-l-4 border-[#1565C0]">
              <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#607D8B] mb-6">Email</p>
              <a 
                href="mailto:arorasukhvinder@outlook.com"
                className="group inline-flex items-center gap-4 text-xl md:text-2xl lg:text-3xl font-['Cabinet_Grotesk',sans-serif] font-bold text-[#1565C0] hover:text-[#0D47A1] transition-colors"
                data-testid="contact-email"
              >
                <div className="w-14 h-14 rounded-full bg-[#1565C0] group-hover:bg-[#0D47A1] flex items-center justify-center transition-colors">
                  <EnvelopeSimple size={28} weight="bold" className="text-white" />
                </div>
                arorasukhvinder@outlook.com
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
